import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  certificationPaths,
  FROM_OVERVIEW_STATE,
  certificationRouteKey,
} from "@/domains/certifications/routes";
import { OverviewHeaderProps } from "@/features/certifications/overview/components/types";

import "./styles.css";

const OverviewHeader = ({ certification, contentKey }: OverviewHeaderProps) => {
  const { t } = useTranslation();

  return (
    <header className="flex flex-col gap-200">
      <div className="flex items-center gap-200 body-xs-regular">
        <span className="overview-eyebrow">
          {t("certification.overview.eyebrow")}
        </span>

        <span className="overview-eyebrow-separator" aria-hidden>
          ·
        </span>

        <Link
          to={certificationPaths.details(certificationRouteKey(certification))}
          state={FROM_OVERVIEW_STATE}
          className="certification-link"
          aria-label={t("certification.overview.learnMoreAbout", {
            title: certification.title,
          })}
        >
          {t("learnMore")}
        </Link>
      </div>

      <h1 className="certification-title">{certification.title}</h1>

      <p className="overview-subtitle body-m-regular">
        {t(`${contentKey}.overviewSubtitle`)}
      </p>
    </header>
  );
};

export default OverviewHeader;
